import React from "react";
import styles from "./Committees.module.scss";
import CardRow from "../../components/_shared/card-row/CardRow";
import {Divider} from "antd";

const Committees_data = [
  {
    title:
      "Komisioni Organizativ i Garave dhe i Ligave të FFK-së",
    email: "komisionipergara@ffk-kosova.com",
    members: [
      { name: "Abdyl Bellopoja", status: "Kryetar" },
      { name: "Lindita Cena", status: "Anëtare" },
      { name: "Baki Berisha", status: "Anëtar" },
    ],
  },
  // {
  //   title:
  //     "Komisioni Organizativ i Garave dhe i Ligave të FFK-së, për Ligën e Dytë dhe Ligat e Juniorëve",
  //   email: "",
  //   members: [
  //     { name: "Ardian Llumnica", status: "Kryetar" },
  //     { name: "Bardhec Seferi", status: "Anëtar" },
  //     { name: "Ekrem Buçinca", status: "Anëtar" },
  //   ],
  // },
  {
    title: "Komisioni Disiplinor dhe i Etikes",
    email: "komisionidisiplinor@ffk-kosova.com",
    members: [
      { name: "Metë Çeku", status: "Kryetar" },
      { name: "Avni Shala", status: "Anëtar" },
      { name: "Remzi Gashi", status: "Anëtar" },
    ],
  },
  {
    title: "Komisioni i Ankesave",
    email: "komisioniperankesa@ffk-kosova.com",
    members: [
      { name: "Haki Xhemajli", status: "Kryetar" },
      { name: "Sitki Baftiu", status: "Anëtar" },
      { name: "Remzi Azemi", status: "Anëtar" },
    ],
  },
  // {
  //   title: "Komisioni i Referëve",
  //   email: "referimi@ffk-kosova.com",
  //   members: [{ name: "Përparim Hasani", status: "Kryetar" }],
  // },
  {
    title:
      "Komisioni për Delegimin e Gjyqtarëve dhe Kontrolluesve për Superligë, Ligën e Parë, Ligën e Dytë dhe Ligën U-21",
    email: "",
    members: [
      { name: "Gani Havolli", status: "Kryetar" },
      { name: "Arta Osmani", status: "Anëtare" },
      { name: "Driton Preniqi", status: "Anëtar" },
      { name: "Kujtim Bajrami", status: "Anëtar" },
    ],
  },
  {
    title: "Komisioni për Vlerësim",
    email: "",
    members: [
      { name: "Ergyn Janovali", status: "Kryetar" },
      { name: "Artan Tahiri", status: "Anëtar" },
      { name: "Kreshnik Vula", status: "Anëtar" },
    ],
  },
  {
    title: "Komisioni i Infrastrukturës dhe Projekteve",
    email: "",
    members: [
      { name: "Isak Rakovica", status: "Kryetar" },
      { name: "Haris Abdixhiku", status: "Anëtar" },
      { name: "Refki Osmani", status: "Anëtar" },
      { name: "Zenun Kodra", status: "Anëtar" },
    ],
  },
  {
    title:
      "Komisioni i Futsalit (Amatorëve, Fillestarëve (Grassroots), dhe Mini-Futboll)",
    email: "",
    members: [
      { name: "Hysni Gjinovci", status: "Kryetar" },
      { name: "Agim Avdyli", status: "Anëtar" },
      { name: "Getart Hyseni", status: "Anëtar" },
    ],
  },
  {
    title: "Komisioni për Statusin e Lojtarëve",
    email: "",
    members: [
      { name: "Bekim Behrami", status: "Kryetar" },
      { name: "Agim Bahtiri", status: "Anëtar" },
      { name: "Besarta Muhadri", status: "Anëtare" },
    ],
  },
  {
    title: "Komisioni i Financave",
    email: "",
    members: [
      { name: "Ymer Mehmeti", status: "Kryetar" },
      { name: "Fatmir Gashi", status: "Anëtar" },
      { name: "Agron Mustafa", status: "Anëtar" },
    ],
  },
  {
    title: "Komisioni Mbikëqyrës i FFK-së",
    email: "",
    members: [
      { name: "Luan Vokshi", status: "Kryetar" },
      { name: "Ajet Shosholli", status: "Anëtar" },
      { name: "Murat Hoxha", status: "Anëtar" },
    ],
  },
];

const Committees = () => {
  return (
    <div className={styles.MainWrapper}>
      <div className={styles.PrimaryTitleWrapper}>
        <h1>KOMISIONET E FFK-SË</h1>
      </div>
      <div className={styles.ListWrapper}>
        {Committees_data.map((data, index) => (
          <div key={index} className={styles.CommitteeRow}>
            <CardRow
              data={{
                title: data.title,
                navigationLink: {
                  link: data?.email && `Email: ${data.email}`,
                  onLinkClick: () => undefined,
                },
              }}
              colors="BLUE"
              align="CENTER"
            />
            <Divider style={{margin:0, height: '5px', backgroundColor: '#' +
                  'D0A550'}}/>
            <div className={styles.MembersWrapper}>
              {data.members.map((member, memberIndex) => (
                <div key={memberIndex} className={styles.Member}>
                  <span className={styles.Name}>{member.name}</span>
                  <span className={styles.Status}>{member.status}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Committees;
